import { Box, Button, SimpleGrid, useToast } from "@chakra-ui/react";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageCard from "../../../components/page-card";
import { translate } from "../../../i18n";
import { OrganizationDto } from "../../../models/organization/dto/organization.dto";
import { useCreateOrganization } from "../hooks/useCreateOrganization";
import { MY_ORGANIZATIONS_QUERY_KEY } from "../hooks/useGetMyOrganizations";
import CompanyNameField from "./CompanyNameField";

export default function CreateOrganization({ title }: { title?: string } = {}) {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const toast = useToast();
    const { mutateAsync, isLoading } = useCreateOrganization(() => {
        const data = queryClient.getQueryData<OrganizationDto[]>(MY_ORGANIZATIONS_QUERY_KEY);
        // Navigate only if 1 organization only has been created
        if (data?.length === 1) {
            navigate('/admin/locations');
        }
    });
    const [organizationName, setName] = useState('');
    return (
        <PageCard title={title ?? translate('tabs.organization')} rightHeader={<Button colorScheme="brand" isLoading={isLoading} isDisabled={!organizationName.trim()} onClick={() => {
            mutateAsync({
                name: organizationName
            }).then(() => {
                setName('');
            }).catch(() => {
                toast({ title: translate('common.error'), status: 'error', duration: 3000 });
            });
        }}>
            {translate('organization.create_organization')}
        </Button>}>
            <SimpleGrid columns={{ sm: 2, }}>
                <Box px={6} pb={6}>
                    <CompanyNameField
                        label={translate('organization.name')}
                        value={organizationName}
                        onChange={setName}
                        placeholder={translate('organization.company_search_placeholder')}
                        helperText={translate('organization.company_search_helper')}
                    />
                </Box>
            </SimpleGrid>
        </PageCard>
    )
}
